module.exports = __webpack_public_path__ + "static/media/cams-ncp-eu.3a3978e7.png";